const getTafInviteInfo = (state) => {
  return state.tafInfo
}
const getReferralData = (state) => {
  return state.referralData
}
export default {
  getTafInviteInfo,
  getReferralData
}



// WEBPACK FOOTER //
// ./src/store/modules/user/taf/getters.js